((document, window, history) => {
	const pushState = history.pushState;
	let lastHeight = window.innerHeight;
	let lastWidth = window.innerWidth;
	const tolerance = 100;

	// default cookie compliance script
	function cookieCompliance() {
		if (document.querySelector('.farlo-ui-biscuit-banner__button')) {
			document.querySelector('.farlo-ui-biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');

				window._farlo.storage.set('cookieCompliance', 'true', 'cookie');
			});
		}

		if (document.querySelector('.farlo-ui-biscuit-banner__button--close')) {
			document.querySelector('.farlo-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');
			});
		}
	}

	// default navicon
	function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active'); document.querySelector('.site-navigation').classList.toggle('site-navigation__nav--active');
			document.body.classList.toggle('site-navigation__nav--open');
		});
	}

	// custom stars
	function farloStars(elem) {
		class Star {
			constructor(x, y, r, color) {
				this.x = x;
				this.y = y;
				this.r = r;
				this.rChange = 0.015;
				this.color = color;

				this.render();
				this.update();
			}

			render() {
				context.beginPath();
				context.arc(this.x, this.y, this.r, 0, 2 * Math.PI, false);
				context.fillStyle = this.color;
				context.fill();
			}

			update() {
				if (this.r > 2 || this.r < .8) {
					this.rChange = -this.rChange;
				}
				this.r += this.rChange;
			}
		}

		const config = {
			canvasContainer: '.' + elem.classList[ 0 ],
			maxStars: 200,
			maxSize: 2,
			colourArray: ['ffffff', 'fcfcff', 'fbfcf1', 'faf9f4'],
			canvasWidth: window.innerWidth,
			canvasHeight: window.innerHeight
		};
		const canvas = document.getElementsByClassName('site-farlo-stars__canvas')[ 0 ];
		const context = canvas.getContext('2d');

		let arrStars = [];
		let C_WIDTH = canvas.width = config.canvasWidth;
		let C_HEIGHT = canvas.height = config.canvasHeight;

		function size() {
			config.canvasWidth = document.querySelector(config.canvasContainer).getBoundingClientRect().width;
			config.canvasHeight = document.querySelector(config.canvasContainer).getBoundingClientRect().height;
			C_WIDTH = canvas.width = config.canvasWidth;
			C_HEIGHT = canvas.height = config.canvasHeight;
		}

		function randomColor() {
			return '#' + config.colourArray[ Math.floor((Math.random() * 3)) ];
		}

		function init() {
			size();

			for (let i = 0; i < config.maxStars; i += 1) {
				const randX = Math.floor((Math.random() * C_WIDTH) + 1);
				const randY = Math.floor((Math.random() * C_HEIGHT) + 1);
				let randR = Math.round((Math.random() * config.maxSize) * 4) * 0.25;
				randR = randR <= 0 ? 0.25 : randR;
				const star = new Star(randX, randY, randR, randomColor());
				arrStars.push(star);
			}
		}

		function update() {
			for (let i = 0; i < arrStars.length; i += 1) {
				arrStars[ i ].update();
			}
		}

		function animate() {
			update();

			context.clearRect(0, 0, C_WIDTH, C_HEIGHT);

			for (let i = 0; i < arrStars.length; i += 1) {
				arrStars[ i ].render();
			}

			requestAnimationFrame(animate);
		}


		window.addEventListener('resize', () => {
			if (lastWidth !== window.innerWidth || (Math.abs(lastHeight - window.innerHeight) > tolerance)) {
				size();
				arrStars = [];
				init();

				lastWidth = window.innerWidth;
				lastHeight = window.innerHeight;
			}
		});

		init();
		animate();
	}

	if (document.querySelector('.wp-block-video')) {
		document.querySelectorAll('video').forEach(function(_sel) {
			_sel.addEventListener('playing', (e) => {
				e.target.parentNode.classList.add('wp-block-video--is-playing');
			});
	
			_sel.onpause = function() {
				_sel.parentNode.classList.remove('wp-block-video--is-playing');
			};
		});
	}
	
	if (document.querySelector('.wp-block-embed')) {
		document.querySelectorAll('.wp-block-embed__wrapper').forEach(function(_sel) {
		  const embedDiv = document.createElement('div');
		  
		  if (!(_sel.querySelector('.wp-block-embed__player'))) {
			embedDiv.className = 'wp-block-embed__player';
			_sel.append(embedDiv);
	  
			embedDiv.addEventListener('click', (e) => {
			  var iframe = e.currentTarget.parentNode.querySelector('iframe');
			  var dataSrc = iframe.getAttribute('data-src');
	  
			  e.currentTarget.parentNode.classList.toggle('wp-block-embed__wrapper--is-playing');
			  
			  if (dataSrc) {
				iframe.setAttribute('src', dataSrc + '&autoplay=1&playsinline=1&muted=1')
			  } else {
				var src = iframe.getAttribute('src');
				iframe.setAttribute('src', src + '&autoplay=1&playsinline=1&muted=1');
			  }
			});
		  }
		});
	  }
	

	// scroll down
	function scrollDown() {
		document.querySelector('.farlo-ui-crm').scrollIntoView({
			behavior: 'smooth'
		});
	}

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		document.documentElement.classList.add(window._farlo.browser.init());

		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}

		if (document.querySelector('.site-farlo-stars')) {
			farloStars(document.querySelector('.site-farlo-stars'));
		}

		if (document.querySelector('.site-scroll-down')) {
			document.querySelector('.site-scroll-down').addEventListener('click', scrollDown);
		}

		document.querySelectorAll('.farlo-ui-crm__form').forEach((_sel) => {
			const formHtml = _sel.innerHTML;

			_sel.addEventListener('submit', (e) => {
				const checkbox = _sel.querySelector('.farlo-ui-crm__input--checkbox');

				e.preventDefault();

				if (!checkbox.checked) {
					_sel.querySelector('.farlo-ui-crm__form-errors').classList.add('farlo-ui-crm__form-errors--show');
					_sel.querySelector('.farlo-ui-crm__form-errors').innerHTML = checkbox.getAttribute('data-error');
					return;
				}

				const data = new URLSearchParams([...new FormData(e.target).entries()]);

				fetch('/app/themes/Farlo/inc/abstractions/Mailchimp/index.php', {
					method: 'POST',
					body: data,
					headers: {
						'Accept': 'application/json',
						'Content-type': 'application/x-www-form-urlencoded',
						'X-WP-Nonce': farloAjaxHandler.nonce
					}
				}).then((response) => response.text()).then((res) => {
					if (res !== '') {
						const details = JSON.parse(res);

						if (details.status === 400) {
							_sel.innerHTML = `<h3>${ details.title }</h3><p>${ details.detail }</p>`;
						} else {
							_sel.innerHTML = `Thank you for signing up, ${ details.full_name }. You'll hear from us very soon!`;

							if (typeof window.dataLayer !== 'undefined') {
								window.dataLayer.push({
									'event': 'GAEvent',
									'eventCategory': 'Interaction',
									'eventAction': 'Signup',
									'eventLabel': 'Success'
								});
							}

							if (typeof fbq !== 'undefined') {
								fbq('trackSingle', '732230957795293', 'Lead');
							}
						}
					}
				}).catch((error) => {
					console.error('There was an error!', error);
				});
			});
		});
	});

	window.addEventListener('scroll', () => {
		if (document.querySelector('.page-template-page-landingpage')) {
			const pageYOffset = window.pageYOffset;
			let opacity = (100 - (pageYOffset * 0.15)) * 0.01;
			opacity = (opacity < 0 ? 0.1 : opacity);
			document.querySelector('.site-header__background').style.opacity = opacity;
		}
	});


})(document, window, history);
